export const global = {
    HTTP_OK: "200",
    HTTP_BAD_REQUEST: "400",

    //TIPO DE DOCUMENTO A CONSULTAR
    TIPO_DOCUMENTO: {
        RECIBO_PROFESIONAL: 'RP'
    },

    //GRUPOS ACEPTADOS EN LA CONSULTA DE EXISTENCIAS
    GRUPO: {
        CONSULTA_EXISTENCIA: [
            '01', '02', '03', '04', '05'
        ],
        GARANTIA: {
            BATERIA: '01',
            BATERIA_MOTO: '0102',
            LLANTA: '04',
            LUBRICANTES: '02',
            REPUESTOS: '03',
            DIVISION_INDUSTRIAL: '05',
            CONSULTA: [
                '01', '03', '04', '05'
            ]
        },
        LOGISTICA_REVERSIVA: '090207',
        TOMAR_PEDIDO: {
            CONSULTA: ['01', '02', '03', '04', '05']
        }
    },

    //TIPOS DE VALIDACIONES DE PERMISOS PARA ACCEDER A RUTAS
    GUARDS: {
        NO_AUTH: 'NO_AUTH',
        AUTH: 'AUTH',
        VENDEDOR: 'EJ VENTAS',
        TELEMERCADERISTA: 'TELEMERCADERISTA',
        LOGISTICA: 'LOGISTICA',
        FACTURADOR: 'FACTURADOR',
        CLIENTE: 'CLIENTE',
        PEDIDO_FACTURADOR: 'PEDIDO_FACTURADOR',
        AUTORIZADOR: 'AUTORIZADOR',
        ADMINISTRADOR:'ADMIN SIMAC MOBILE',
        AUXILIAR_ADMINISTRATIVO_FACTURACION: 'AUXILIAR ADMINISTRATIVO FACTURACION',
        AUXILIAR_FACTURACION_CEDI: 'AUXILIAR FACTURACION CEDI',
        AUXILIAR_ADMINISTRATIVO_CEDI: 'AUXILIAR ADMINISTRATIVO CEDI',
        VALIDADOR: 'VALIDADOR',
    },

    SESSION_ITEMS: {
        CLIENTE: 'cliente',
        DETALLE_GARANTIA: 'detalleGarantia',
        MENU_DERECHO: 'menuDerecho',
        TOTAL_ITEM: 'totalItem',
        USU_SESION: 'usuario',

        ITEMS_MENU_DERECHO: 'itemsMenuDerecho',
        MENU_COBRANZA: 'itemsMenuCobranza',
        MENU_PEDIDO: 'itemsMenuPedido',

        LOGISTICA_REVERSIVA: {
            CARRITO: 'logisticaReversiva',
            ITEMS: 'itemLogisticaReversiva'
        },
        ROTACION: {
            CARRITO: 'rotacion',
            ITEMS: 'itemRotacion'
        },
        GARANTIA: {
            CARRITO: 'garantia',
            ITEMS: 'itemGarantia',
            TIPO: 'tipoGarantia',
        },
        RECAUDO: {
            CARRITO: 'recaudo',
            ITEM: 'itemRecaudo'
        },
        PEDIDO: {
            INVENTARIO: 'inventario',
            INVENTARIO_VISITA: 'inventarioVisita',
            HACER_SUGERIDO: 'hacerSugerido',
            SUGERIDO: 'sugerido',
            SUGERIDO_1: ['sugerido', 'sugerido1' ],
            SUGERIDO_2: ['sugerido', 'sugerido2' ],
            SUGERIDO_3: ['sugerido', 'sugerido3' ],
            ITEM_SUGERIDO: 'pedidoSugeridoDTO',
            CARRITO: 'pedido',
            ITEMS: 'itemPedido',
            ITEMS_PRE_PROMO: 'itemPrePromo',
            ITEMS_MENU_DERECHO: 'itemsMenuDerecho',
            TIPO_PEDIDO: 'tipoPedido',
            FORMAS_PAGO: 'formasPago',
            NUMERO_REMISIONES: 'numeroRemisiones',
            ENCABEZADO_REMISIONES: 'encabezadoRemisiones',
            REMISIONES: 'remisiones',
            MODIFICAR_PEDIDO: 'modificarPedido',
            PEDIDO_ANTERIOR: 'pedidoAnterior',
            PROMOCIONES_QUE_APLICAN: 'promocionesQueAplican',
            CLIENTE_RECOGE_REMISION:'CLIENTE_RECOGE_REMISION'
        },
        CARTERA : {
            DATOS_CARTERA : "datosCartera"
        },
        NOTA_CREDITO : {
            ITEM : "notaCredito"
        },
        CONSULTA : {
            FORMAS_PAGO : "formaPago"
        },
        FACTURADOR: {
            PEDIDO: "pedidoFacturador"
        },

        TIPO_AUTORIZADOR: 'tipoAutorizador'
    },

    //CODIGOS DE REFERENCIAS
    CODIGO_OBSEQUIO: "OBSEQUIO",
    CODIGO_DESCUENTO: "DESCTO",
    CODIGO_DESCUENTO_FINANCIERO: "DESCTO_FINAN",

    //CODIGOS DE TIPOS DE FORMA DE PAGO
    TIPOS_FORMA_PAGO: {
        EFECTIVO: 'EF',
        CHEQUE_POSFECHADO: 'CP'
    },

    ESTADOS_GARANTIA: [
        { id:null , valor:'Cualquier Estado'},
        { id:'C' , valor:'Cerrado'},
        { id:'D' ,valor: 'En Diagnostico'},
        { id:'P' ,valor: 'Pendiente por Orden Recole'},
        { id:'N',valor: 'Pendiente por autorización'},
        { id:'O',valor: 'En orden de recolección'},
        { id:'A',valor: 'Aceptada'}
    ],
    
    TIPOS_PROMOCION: {
        DESCUENTO: 'DESCUENTO',
        PRECIO_FIJO: 'PRECIO_FIJO',
        DESCUENTO_FIJO: 'DESCUENTO_FIJO',
        OBSEQUIO: 'OBSEQUIO'
    },

    //CANTIDAD DE ITEMS PERMITIDOS EN UN PEDIDO
    CANTIDAD_ITEMS_PEDIDO_GRUPO_IGUAL: 50,
    CANTIDAD_ITEMS_PEDIDO_GRUPO_DISTINTO: 25,

    TIPO_PEDIDO: {
        DESCRIPCION : {            
            ENERGITECA: 'ENERGITECA',
            REMISION: 'REMISION',
            CLIENTE_RECOGE_REMISION: 'CLIENTE_RECOGE_REMISION'
        },
        CODIGO:{
            REMISION: 'REM',
            FORMA_PAGO : 'PTC'
        }
    }, 

    TIPO_SUCURSAL: {
        CEDI: '02',
        ENERGITECA: '03',
    },

    NIVELES:[1,2,3],

    TIPOS_AUTORIZADOR:{
        Margen:'Margen',
        Cartera:'Cartera',
        MargenCartera:'MargenCartera',
        FormaPago:'FormaPago',
        CarteraFormaPago:'CarteraFormaPago',
        Logistica:'Logistica',
        MargenPedidoMinimo:'MargenPedidoMinimo',
        PedidoMinimo:'PedidoMinimo'
},
    CONSTANTES: {
        SI: 'S',
        NO: 'N',
        CLIENTE_RECOGE_REMISION:'CLIENTE_RECOGE_REMISION',
        CONTADO_CLIENTE_RECOGE :'CONTADO_CLIENTE_RECOGE',
        CONTADO_NORMAL:'CONTADO_NORMAL'
    },
}